const DATE_W3C = 'YYYY-MM-DD[T]H:MM:SSZ';
const DATE_IAP_DATE = 'M/D/YY';
const DATE_IAP_TIME = 'h:mma';
const DATE_IAP = DATE_IAP_DATE + ' ' + DATE_IAP_TIME;

const DATE_MYSQL = 'YYYY-MM-DD HH:mm:ss';
const DATE_MYSQL_DATE = 'YYYY-MM-DD';

const COUNTRIES_UNITED_STATES = 235;

const STATES_FLORIDA = 9;

// APIRoot holds the absolute URL root
// like `https://api.<hostname>`
let /** string */ APIRoot = /** @type {string} */(window['location']['hostname']);
if (APIRoot.substring(0, 4) !== 'api.' && !/^((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)(\.|$)){4}$/.test(window.location.hostname)) {
	APIRoot = 'api.'+APIRoot;
}
APIRoot = 'https://'+APIRoot;

let /** @type {function(string):string} */ escapeRegExp;

(function () {
  // Referring to the table here:
  // https://developer.mozilla.org/en/JavaScript/Reference/Global_Objects/regexp
  // these characters should be escaped
  // \ ^ $ * + ? . ( ) | { } [ ]
  // These characters only have special meaning inside of brackets
  // they do not need to be escaped, but they MAY be escaped
  // without any adverse effects (to the best of my knowledge and casual testing)
  // : ! , =
  // my test "~!@#$%^&*(){}[]`/=?+\|-_;:'\",<.>".match(/[\#]/g)

  const specials = [
        // order matters for these
          "-"
        , "["
        , "]"
        // order doesn't matter for any of these
        , "/"
        , "{"
        , "}"
        , "("
        , ")"
        , "*"
        , "+"
        , "?"
        , "."
        , "\\"
        , "^"
        , "$"
        , "|"
    ]

      // I choose to escape every character with '\'
      // even though only some strictly require it when inside of []
    , regex = RegExp('[' + specials.join('\\') + ']', 'g');

    escapeRegExp = function(/** string */ str) {
        return str.replace(regex, "\\$&");
    };

	// test escapeRegExp("/path/to/res?search=this.that")
}());

/**
 * @param {string} s
 * @return {string}
 */
function utos(s) {
    return unescape(encodeURIComponent(s));
}

/**
 * @param {string} s
 * @return {string}
 */
function stou(s) {
    return decodeURIComponent(escape(s));
}

const Base64URLEncode = new RegExp('[+/]', 'g');

/**
 * @param {string} s
 * @return {string}
 */
function base64url_encode(s) {
    return rtrim(btoa(s), '=').replace(Base64URLEncode, function (/** string */ m) {
        return {
            '+': '-',
            '/': '_'
        }[m];
    });
}

const b64u = base64url_encode;

const Base64URLDecode = new RegExp('[\-_]', 'g');

/**
 * @param {string} s
 * @return {string}
 */
function base64url_decode(s) {
    s = s.replace(Base64URLDecode, function (/** string */ m) {
        return {
            '-': '+',
            '_': '/'
        }[m];
    });

    const r = s.length % 4;
    if (r !== 0){
        s += '='.repeat(r);
    }

    return atob(s);
}

const unb64u = base64url_decode;

/**
 * @param {string} str
 * @param {string?} charlist
 * @return {string}
 */
function rtrim(str, charlist) {
    charlist = !charlist ? ' \\s\u00A0' : escapeRegExp(charlist);

    const re = new RegExp('[' + charlist + ']+$', 'g');

    return str.replace(re, '');
}

const DEFAULT_ERROR_MESSAGE = 'Something went wrong.';

/**
 * @constructor
 * @struct
 */
function AjaxOptions() {}

/** @param {Object<string,?>} data */
AjaxOptions.prototype.success = function (data) {};

/**
 * @param {Object<string,?>|string|boolean} err
 * @param {Object<string,*>} resp
 */
AjaxOptions.prototype.error = function (err, resp) {};

AjaxOptions.prototype.complete = function () {};

/** @type {Object<string,?>} */
AjaxOptions.prototype.data;

/** @type {boolean} */
AjaxOptions.prototype.defaultError;

/** @type {boolean} */
AjaxOptions.prototype.async;

/** @type {string} */
AjaxOptions.prototype.url;

/** @type {string} */
AjaxOptions.prototype.method;

/** @type {!jQuery} */
AjaxOptions.prototype.scope;

/**
 * @param {!AjaxOptions|Object<string,?>} Options
 * @return {jQuery.jqXHR}
 */
function Ajax(Options) {
	const Settings = /** @type {!AjaxOptions} */ ($.extend({
		success: $.noop,
		error: $.noop,
		complete: $.noop,
		data: {},
		defaultError: true,
		async: true,
        scope: $(document),
        method: 'get',
	}, Options));

    const rest = /^\/rest\//.test(Settings.url);

    const headers = {};
    let data = Settings.data;
    if (!rest) {
        Settings.method = Settings.method.toLowerCase();
        if (Settings.method === 'get' && (Settings.url + $.param(data)).length > 1000 * 2) {
            Settings.method = 'post';
        }
    } else {
        if (!$.isEmptyObject(data)) {
            data = JSON.stringify(data);
        } else {
            data = undefined;
        }
        headers['content-type'] = 'application/json';
    }

    if (Settings.url[0] === '/') {
        Settings.url = APIRoot + Settings.url;
    }

	let /** (boolean|string|Object<string,?>) */ err = false;
	let /** Object<string,*> */ resp = {};
	const xhr = $.ajax({
		'url': Settings.url,
		'method': Settings.method,
        'data': data,
        'headers': headers,
        'async': Settings.async,
        'xhrFields': {
            'withCredentials': true,
        },
		'success': function (/** Object<string,?> */ response) {
			if (typeof response === 'object' && response !== null) {
				resp = response;
				if ('data' in response) {
					Settings.success(response['data']);
				} else if ('error' in response) {
					if (typeof response['error']['message'] === 'object' && response['error']['message'] !== null) {
						err = /** @type {Object<string,?>} */ (response['error']['message']);
					} else if (typeof response['error']['message'] === 'string') {
						err = /** @type {string} */ (response['error']['message']);
					} else {
						err = true;
					}
				} else {
					err = true;
				}
			} else {
				err = true;
			}
		},
		'error': function (/** Object<string,*> */ response) {
            if (rest && typeof response === 'object' && response !== null && 'responseText' in response) {
                try {
                    err = /** @type {string} */(JSON.parse(/** @type {string} */(response['responseText']))['error']);
                } catch (_) { }
                return;
            }

			if (response['statusText'] === 'abort') {
				return;
			}
			err = true;
		},
		'complete': function () {
			Settings.scope.find('.invalid-feedback').remove();
			Settings.scope.find('.is-invalid').removeClass('is-invalid');
			if (err !== false) {
				const ErrorDialog = function (/** string */ msg) {
					Dialog({
						title: 'Error!',
						text: msg,
						type: 'error'
					});
                }

                const errAttr = !rest ? 'name' : 'data-error';

				if (typeof err === 'object') {
					let /** !jQuery */ $err = $();
					let Errors = '';
					for (const n in err) {
                        const $e = Settings.scope.find(`[${errAttr}="${n}"]`);
						if ($e.length !== 0) {
							$err = $err.add($e.addClass('is-invalid').after($('<div class="invalid-feedback"></div>').text(/** @type {string} */(err[n]).capitalize())));
						} else {
							Errors += err[n] + "\n";
						}
                    }
                    Settings.scope.find(`.is-invalid[${errAttr}]`).not($err).removeClass('is-invalid').next('.invalid-feedback').remove();
                    setTimeout(function () {
                        $err.one('input change', /** @this {Element} */ function () {
                            $(this).removeClass('is-invalid').next('.invalid-feedback').remove();
                        });
                        if ($err.length !== 0) {
                            const /** Element */ e = $err.first()[0];
                            e.scrollIntoView(true);
                            window.scrollBy(0, -150);
                            setTimeout(function () {
                                $err.first().trigger('focus');
                            });
                        }
                    });
					if (!strempty(Errors)) {
						ErrorDialog(Errors);
					}
				} else {
					if (Settings.defaultError) {
						ErrorDialog(/** @type {string} */ (err === true ? DEFAULT_ERROR_MESSAGE : err));
					}
				}
				Settings.error(err, resp);
			}
			Settings.complete();
		}
    });
    return xhr;
}

/**
 * @constructor
 * @struct
 */
const DialogSettings = function () {};

/**
 * @param {Function} resolve
 * @param {function((boolean|string))} showError
 */
DialogSettings.prototype.check = function (resolve, showError) {};

/**
 * @param {string} inputValue
 */
DialogSettings.prototype.success = function (inputValue) {};

DialogSettings.prototype.canceled = function () {};

/** @type {string} */
DialogSettings.prototype.confirm;

/** @type {string} */
DialogSettings.prototype.cancel;

/** @type {string} */
DialogSettings.prototype.title;

/** @type {string} */
DialogSettings.prototype.text;

/** @type {string} */
DialogSettings.prototype.html;

/** @type {string} */
DialogSettings.prototype.type;

/** @type {string} */
DialogSettings.prototype.input;

/** @type {string} */
DialogSettings.prototype.inputValue;

/** @type {string} */
DialogSettings.prototype.width;

/** @type {boolean} */
DialogSettings.prototype.hideConfirm;

/** @type {boolean} */
DialogSettings.prototype.unclosable;

/** @type {boolean} */
DialogSettings.prototype.hideCancel;

/** @type {string} */
DialogSettings.prototype.cancelButtonClass;

/** @type {string} */
DialogSettings.prototype.confirmButtonClass;

/**
 * @param {!DialogSettings|Object<string,?>} Options
 */
function Dialog(Options) {
	const Settings = /** @type {!DialogSettings} */ ($.extend({
		check: $.noop,
		success: $.noop,
		confirm: 'Continue',
		canceled: $.noop,
		close: true,
		unclosable: false,
		hideConfirm: false,
		hideCancel: false,
		input: null,
		width: '500px',
		confirmButtonClass: 'btn btn-primary ladda-button',
		cancelButtonClass: 'btn btn-secondary ml-2'
	}, Options));

	const HasClose = !strempty(Settings.cancel);

	let /** number */ ShowLaddaTimeout;
	let /** LaddaObject */ l;

	let preConfirm = null;
	if (Settings.check !== $.noop) {
		preConfirm = function () {
			return new Promise(function (resolve) {
				swal.disableButtons();
				ShowLaddaTimeout = setTimeout(function () {
					l.start();
				}, 500);

				Settings.check(resolve, function (err) {
					swal.showValidationError(typeof err === 'string' ? err : DEFAULT_ERROR_MESSAGE);
					swal.enableButtons();
					clearTimeout(ShowLaddaTimeout);
					l.stop();
					resolve();
				});
			});
		};
	}

	const SwalOptions = {
		'title': Settings.title,
		'text': Settings.text,
		'html': Settings.html,
		'type': Settings.type,
		'input': Settings.input,
		'inputValue': Settings.inputValue,
		'width': Settings.width,
		'showConfirmButton': !Settings.hideConfirm,
		'confirmButtonText': Settings.confirm,
		'showCancelButton': HasClose && !Settings.unclosable && !Settings.hideCancel,
		'cancelButtonText': !HasClose ? 'Cancel' : Settings.cancel,
		'showCloseButton': HasClose && !Settings.unclosable,
		'confirmButtonClass': Settings.confirmButtonClass,
		'cancelButtonClass': Settings.cancelButtonClass,
		'allowOutsideClick': !Settings.unclosable,
		'allowEscapeKey': !Settings.unclosable,
		'preConfirm': preConfirm,
        // 'cancelButtonClass': 'btn ml-2',
        'reverseButtons': true,
	};

	for (const Option in SwalOptions) {
		if (typeof SwalOptions[Option] === 'undefined' || SwalOptions[Option] === null) {
			delete SwalOptions[Option];
		}
	}

	swal(SwalOptions).then(function (/** Object<string,?> */ result) {
		clearTimeout(ShowLaddaTimeout);
		l.stop();
		if (result['value']) {
			Settings.success(result['value']);
		} else if (result['dismiss'] === 'cancel') {
			Settings.canceled();
		}
	});

	const $ConfirmButton = $(swal.getConfirmButton());
	// const $CancelButton = $(swal.getCancelButton());
	$ConfirmButton.attr({
		'data-style': 'expand-left',
		// 'class': 'swal2-confirm btn btn-primary ladda-button'
	});
	// $CancelButton.attr({'class': 'swal2-cancel btn ml-2'});
	l = Ladda.create($ConfirmButton[0]);
}

/**
 * @param {?(string|undefined)} s
 * @return {boolean}
 */
function strempty(s) {
	if (typeof s === 'undefined') {
		return true;
	}

	if (s === null) {
		return true;
	}

	let i = s.length;
	while (i--) {
		if (' \t\n\r\v'.indexOf(s[i]) === -1) {
			return false;
		}
	}
	return true;
}

/**
 * @param {*} s
 * @return {boolean}
 */
function str(s) {
	if (typeof s !== 'string') {
		return false;
	}

	return !strempty(s);
}

/**
 * @return {number}
 */
function rem() {
	const html = document.getElementsByTagName('html')[0];
	return parseInt(window.getComputedStyle(html)['fontSize'], 10);
}

const get_selected_text = (/** @return {function():string} */ function() {
    if (window.getSelection || document.getSelection) {
        return function () {
            const selection = /** @type {function():Object<string,?>} */ (window.getSelection || document.getSelection)();
            if (typeof selection['text'] === "string") {
                return selection['text'];
            } else {
                return selection.toString();
            }
        };
    } else if (document.selection && document.selection.type !== "Control") {
        return function () {
            return document.selection.createRange().text;
        };
    }
    return function () {
        return '';
    };
})();

(function ($) {
	/**
	 * @this {!jQuery}
	 * @return {!jQuery}
	 */
	$.fn.hideOptions = function () {
		return this.each(/** @this {Element} */ function () {
			const $this = $(this);
			if (typeof $this.closest('select').data('originalHTML') === 'undefined') {
				$this.closest('select').data('originalHTML', $this.closest('select').html());
			}
			$this.detach();
		});
	};

	$.fn.resetOptions =
	/**
	 * @this {!jQuery}
	 * @return {!jQuery}
	 */
	function () {
		return this.each(/** @this {Element} */ function () {
			const $this = $(this);
			if (typeof $this.data('originalHTML') !== 'undefined') {
				const Value = /** @type {string} */ ($this.val());
				$this.html(/** @type {string} */ ($this.data('originalHTML'))).val(Value);
			}
		});
	};

	$.fn.classList =
	/**
	 * @this {!jQuery}
	 * @return {Array<string>}
	 */
	function() {
		const c = this.attr('class');
		if (typeof c === 'string') {
			return c.split(/\s+/);
		}
		return [];
	 };
}(jQuery));

/**
 * @return {boolean}
 */
function Mobile() {
	return /Mobi/i.test(navigator.userAgent) || /Android/i.test(navigator.userAgent);
}

/**
 * @param {!Big|string} n
 * @return {string}
 */
function dollar_format(n) {
	return Number(n).toLocaleString('en-US', {
		style: 'currency',
		currency: 'USD',
	});
}

/**
 * @param {string} jsonString
 * @return {Object}
 */
function tryParseJSON(jsonString) {
	try {
		const o = JSON.parse(jsonString);
		// Handle non-exception-throwing cases:
		// Neither JSON.parse(false) or JSON.parse(1234) throw errors, hence the type-checking,
		// but... JSON.parse(null) returns null, and typeof null === "object",
		// so we must check for that, too. Thankfully, null is falsey, so this suffices:
//		if (o && typeof o === "object") {
		return /** @type {Object} */ (o);
//		}
	} catch (e) {
		//do nothing
	}

	return {};
}

/**
 * @constructor
 * @struct
 */
const ImageUploadSettings = function () {};

/**
 * @param {Object<string,?>} data
 */
ImageUploadSettings.prototype.success = function (data) {};

/** @type {!jQuery} */
ImageUploadSettings.prototype.dropZone;

/** @type {!jQuery} */
ImageUploadSettings.prototype.button;

/** @type {string} */
ImageUploadSettings.prototype.input;

/** @type {string} */
ImageUploadSettings.prototype.url;

/** @type {string} */
ImageUploadSettings.prototype.template;

/** @type {string} */
ImageUploadSettings.prototype.deleteLink;

/** @type {string} */
ImageUploadSettings.prototype.image;

/** @type {string} */
ImageUploadSettings.prototype.parent;

/** @type {string} */
ImageUploadSettings.prototype.link;

/**
 * @param {!ImageUploadSettings|Object<string,?>} Settings
 */
function ImageUpload(Settings) {
	const settings = /** @type {!ImageUploadSettings} */ ($.extend({
		url: APIRoot+'/ajax/uploadimage3'
	}, Settings));

	const $ImageTemplate = settings.dropZone.find(settings.template);
	const $Image = $ImageTemplate.clone().removeClass('d-none');
	const c = $Image.classList();
	for (let i = 0; i < c.length; i++) {
		if (c[i].match(/\-template/) !== null) {
			$Image.removeClass(c[i]);
		}
	}
	$ImageTemplate.remove();

	settings.dropZone.on('click', settings.deleteLink, /** @this {Element} */function () {
		const $this = $(this);
		const $p = $this.closest(settings.parent);
		$this.closest(settings.image).remove();
        if ($p.find('*').filter(/** @this {Element} */function () { return $(this).is(settings.image) }).length === 0) {
			$p.addClass('d-none');
		}
		return false;
	});

	let filestoupload = 0;
	let ProgressObject = {};
	settings.dropZone.find(settings.input).each(/** @this {Element} */ function () {
		const $this = settings.dropZone.find(settings.input);

		let /** boolean|string */ err = false;
		let /** !LaddaObject */ l;

		let /** number */ FileUploadTimer;
		let /** number */ FileUploadInterval;

		$this.attr({
			'data-url': settings.url,
			'name': 'Image'
		}).fileupload({
			'dropZone': settings.dropZone,
			'dataType': 'text',
			'start': function () {
				ProgressObject = {};
				filestoupload = 0;

				l = Ladda.create(settings.button[0]);
				l.start();
				err = false;
			},
			progress: function (_, /** Object<string,?> */ data) {
				let /** number */ progress = 0;
				ProgressObject[data['files'][0]['name']] = parseInt(/** @type {number} */ (data['loaded']) / /** @type {number} */ (data['total']) * 100, 10);
				$.each(ProgressObject, function (_, /** number */ v) {
					progress += v;
				});
				progress = progress / filestoupload;

				l.setProgress(progress / 100);
			},
			done: function (_, /** Object<string,string> */ data) {
				const /** string */ result = data['result'];
				clearTimeout(FileUploadTimer);
				clearInterval(FileUploadInterval);

				const response = tryParseJSON(result);
				if (typeof response === 'object' && 'data' in response) {
                    const d = /** @type {Object<string,?>} */ (response['data']);
                    const $p = $Image.clone().attr({
						'data-image-id': /** @type {string} */ (d['imageid']),
						'data-original': /** @type {string} */ (d['files']['original']['file'])
                    });
                    settings.dropZone.find(settings.parent).removeClass('d-none').append($p);
                    if ('thumbnail' in /** @type {Object<string,*>} */ (d['files'])) {
                        $p.find('img').attr({
                            'src': /** @type {string} */ (d['files']['thumbnail']['file']),
                            'alt': /** @type {string} */ (d['name']),
                            'title': /** @type {string} */ (d['name'])
                        }).end().find('a').attr({
                            'href': /** @type {string} */ (d['files']['raster']['file'])
                        }).end();
                    } else {
                        $p.css({
                            'width': 'auto',
                            'height': 'auto',
                            'padding-right': '1rem',
                        }).find('*').filter(/** @this {Element} */function () { return $(this).is(settings.link) }).removeAttr('data-fancybox').attr({
                            'href': /** @type {string} */ (d['files']['original']['file']),
                            'download': /** @type {string} */ (d['name']),
                        }).empty().append($('<div></div>').text(/** @type {string} */ (d['name'])+' ('+humanFileSize(/** @type {number} */ (d['files']['original']['size']))+')'));
                    }
				} else if (typeof response === 'object' && 'error' in response) {
					err = /** @type {string} */ (response['error']['message']);
				} else {
					err = true;
				}
			},
			stop: function () {
				l.stop();
				if (err !== false) {
					Dialog({
						'title': 'Error!',
						'text': err === true ? DEFAULT_ERROR_MESSAGE : err,
						'type': 'error'
					});
				}
			}
		}).on('fileuploadadd', function (_, /** Object<string,function():!jQuery.jqXHR> */ data) {
			let jqXHR = data['submit']();
			$(document).on('keyup', function (/** Event */ e) {
				if (e.keyCode == 27) {
					jqXHR.abort();
				}
			});
			filestoupload++;
		}).on('fileuploadfail', function (_, /** Object<string,string> */ data) {
			if (data['errorThrown'] === 'abort') {
				clearTimeout(FileUploadTimer);
				clearInterval(FileUploadInterval);
			}
		});

		settings.button.on('click', /** @this {Element} */ function () {
			settings.dropZone.find(settings.input).trigger('click');
		});
	});
}

const $_GET =
(/**
 * @param {string} qs
 * @return {Object<string,string>}
 */
function (qs) {
	qs = qs.split("+").join(" ");
	let params = {},
			tokens,
			re = /[?&]?([^=]+)=([^&]*)/g;
	while (tokens = re.exec(qs)) {
		params[decodeURIComponent(tokens[1])]
				= decodeURIComponent(tokens[2]);
	}

	return params;
})(document.location.search);

/**
 * @param {!jQuery} $e
 */
function ScrollTo($e) {
	const h = $e.outerHeight();
	const w = $(window).height();
	$('html, body').animate({
		'scrollTop': h > w ? $e.offset().top - rem() * 1 : $e.offset().top - (w - h) / 4
	}, 300, 'easeOutCirc');
	$(window).one('scroll', function () {
		$e.clearQueue().stop();
	});
}

/**
 * @param {string} Event
 */
function gtm(Event) {
    try {
        console.log('triggering ' + Event);
        $(document).trigger(Event);
    } catch (_) { }
    window['dataLayer'] = /** @type {Array<*>} */(window['dataLayer']) || [];
    /** @type {Array<*>} */(window['dataLayer']).push({
        'event': Event,
    });
}

/**
 * @return {string}
 */
String.prototype.class = function () {
    return this.replace(/[^A-Za-z0-9]+/g, ' ').trim().toLowerCase().replace(/\s+/g, '-');
};

/**
 * @param {number} bytes
 * @param {boolean} [si=false]
 * @return {string}
 */
function humanFileSize(bytes, si) {
	si = typeof si === 'boolean' ? si : false;

	const Threshold = si ? 1000 : 1024;
	if (Math.abs(bytes) < Threshold) {
		return bytes.toString() + ' B';
	}
	const Units = si ? ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'] : ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'];
	let u = -1;
	do {
		bytes /= Threshold;
		++u;
	} while (Math.abs(bytes) >= Threshold && u < Units.length - 1);
	return String(Number(bytes.toFixed(1))) + ' ' + Units[u];
}

let SettingHash = false;

/**
 * @constructor
 * @return {!URIHash}
 */
function URIHash() {};

/**
 * @this {!URIHash}
 * @return {Object<string,string>|undefined}
 */
URIHash.dump = function () {
    let hash = document.location.hash;
    const dump = new Object();
    if (hash.length == 0)
        return dump;
    hash = hash.substring(1).split('&');
    for (const key in hash) {
        const pair = hash[Number(key)].split('=');
        if (pair.length != 2 || pair[0] in dump)
            return undefined;
        dump[decodeURIComponent(pair[0].replace(/\+/g, '%20'))] = decodeURIComponent(pair[1].replace(/\+/g, '%20'));
    }
    return dump;
};

/**
 * @param {Object<string,string>} array
 */
URIHash.load = function (array) {
    let first = true;
    let hash = '';
    for (const key in array) {
        if (!first)
            hash += '&';
        hash += escape(key) + '=' + escape(array[key]);
    }
    document.location.hash = hash;
}

/**
 * @param {string} key
 * @return {string}
 */
URIHash.get = function (key) {
    return URIHash.dump()[key];
}

/**
 * @param {string} key
 * @param {string} value
 */
URIHash.set = function (key, value) {
    SettingHash = true;
    const dump = URIHash.dump();
    dump[key] = value;
    const /** Array<string> */ hash = new Array();
    for (const k in dump) {
        hash.push(escape(k) + '=' + escape(dump[k]));
    }
    document.location.hash = hash.join('&');
    SettingHash = false;
}

/**
 * @param {string} str
 * @return {number}
 */
function GetDigits(str) {
    return parseInt(str.replace('/\D+/g', ''), 10);
}

let UUIDLoaded = false;
if ('uuid' in window && UUIDLoaded) {
    UUIDLoaded = true;
    uuid = uuid.v1;
}

(function($){
    /**
     * @this {!jQuery}
     * @return {!Object<string,string>}
     */
    $.fn.getStyleObject = function () {
        const dom = /** @type {Element} */(this.get(0));
        let /** CSSStyleDeclaration */ style;
        const /** !Object<string,string> */ returns = {};
        if (typeof window['getComputedStyle'] === 'function') {
            const getComputedStyle = /** @type {function(Element,*):!CSSStyleDeclaration} */(window['getComputedStyle']);
            const camelize = function(_, /** string */ b){
                return b.toUpperCase();
            };
            style = getComputedStyle(dom, null);
            let /** number */ l;
            for (let i = 0, l = style.length; i < l; i++){
                const prop = style[i];
                const camel = prop.replace(/\-([a-z])/g, camelize);
                const val = style.getPropertyValue(prop);
                returns[camel] = val;
            };
            return returns;
        };
        if (style = dom.currentStyle) {
            for (const prop in style) {
                returns[prop] = style[prop];
            };
            return returns;
        };
        return {};
    }
})(jQuery);

const entityMap = {
	'&': '&amp;',
	'<': '&lt;',
	'>': '&gt;',
	'"': '&#34;',
	"'": '&#39;'
};

/**
 * @param {string} s
 * @return {string}
 */
function html(s) {
    return s.replace(/[&<>"']/g, function (/** string */ s) {
		return entityMap[s];
	});
}

/**
 * @return {string}
 */
String.prototype.capitalize = function () {
    return this.charAt(0).toUpperCase() + this.slice(1);
}

$('stock-item').each(/** @this {Element} */ function () {
    const $this = $(this);

    Ajax({
        url: '/helen/getstockitembutton',
        data: {
            'name': $this.attr('name'),
        },
        success: function (/** Object<string,*> */ d) {
            const $content = $(/** @type {string} */(d['content']));
            $this.replaceWith($content)
            console.log($content, $content.find('button'));
            $content.find('button').on('click',/** @this {Element} */ function () {
                const $this = $(this);
                $this.attr('disabled', true);

                const originalContent = /** @type {string} */($this.html());
                $this.html('<i class="fa fa-refresh fa-spin"></i> Loading');

                Ajax({
                    url: '/helen/newcartitem',
                    data: {
                        'StockItemID': $this.attr('data-stock-item-id'),
                    },
                    success: function () {
                        window.location = '/cart';
                    },
                    complete: function () {
                        $this.attr('disabled', false).html(originalContent);
                    },
                });
            });
        },
        defaultError: false,
        error: function () {
            $this.remove();
        },
    });
});
